import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, FolderTree, ShoppingCart, Users, Ticket, Settings as Cog, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, id: "dashboard" },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart, id: "orders" },
  { to: "/admin/products", label: "Products", icon: Package, id: "products" },
  { to: "/admin/categories", label: "Categories", icon: FolderTree, id: "categories" },
  { to: "/admin/customers", label: "Customers", icon: Users, id: "customers" },
  { to: "/admin/discounts", label: "Discount Codes", icon: Ticket, id: "discounts" },
  { to: "/admin/settings", label: "Settings", icon: Cog, id: "settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="flex min-h-screen bg-[#F8FAFC]">
      <aside className="fixed inset-y-0 left-0 flex w-60 flex-col border-r border-border bg-white" data-testid="sidebar">
        <div className="flex items-center gap-2 px-6 py-6">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary font-head text-sm font-extrabold text-primary-foreground">AT</div>
          <div>
            <div className="font-head text-base font-extrabold leading-none tracking-tight">ATLABS</div>
            <div className="overline text-muted-foreground">Admin Console</div>
          </div>
        </div>
        <nav className="flex-1 space-y-1 px-3">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.id}`}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors duration-200 ${
                  isActive ? "bg-secondary text-foreground" : "text-muted-foreground hover:bg-muted hover:text-foreground"
                }`
              }
            >
              <n.icon className="h-4 w-4" />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-border p-3">
          <div className="mb-2 px-3 text-xs text-muted-foreground truncate">{user?.email}</div>
          <button
            onClick={logout}
            data-testid="logout-btn"
            className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-muted-foreground transition-colors duration-200 hover:bg-muted hover:text-foreground"
          >
            <LogOut className="h-4 w-4" /> Sign out
          </button>
        </div>
      </aside>
      <main className="ml-60 flex-1 p-8">
        <Outlet />
      </main>
    </div>
  );
}
